import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { NAV, PRODUCTS } from '../../data/content';

export default function SearchDialog({ open, onOpenChange }) {
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  const index = useMemo(() => {
    const items = [];
    NAV.forEach((n) => {
      items.push({ label: n.label, to: n.to, group: 'Pages' });
      (n.children || []).forEach((c) => items.push({ label: c.label, to: c.to, group: 'Pages' }));
    });
    PRODUCTS.forEach((p) =>
      items.push({ label: p.name, to: `/products/${p.slug}`, group: 'Products' })
    );
    const seen = new Set();
    return items.filter((i) => {
      if (seen.has(i.to + i.label)) return false;
      seen.add(i.to + i.label);
      return true;
    });
  }, []);

  const results = q
    ? index.filter((i) => i.label.toLowerCase().includes(q.toLowerCase()))
    : index;

  const go = (to) => {
    onOpenChange(false);
    setQ('');
    navigate(to);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="top-[15%] max-w-xl translate-y-0 gap-0 rounded-none border-line p-0"
        data-testid="search-dialog"
      >
        <DialogTitle className="sr-only">Search</DialogTitle>
        <DialogDescription className="sr-only">
          Search across Banmore products and pages
        </DialogDescription>
        <div className="flex items-center gap-3 border-b border-line px-5 py-4">
          <Search className="h-5 w-5 text-steel" />
          <input
            autoFocus
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products & pages…"
            className="w-full bg-transparent font-sans text-base text-navy outline-none placeholder:text-steel"
          />
        </div>
        <div className="max-h-80 overflow-y-auto p-2">
          {results.length === 0 && (
            <p className="px-3 py-6 text-center text-sm text-steel">No results found.</p>
          )}
          {results.map((r) => (
            <button
              key={r.to + r.label}
              data-testid={`search-result-${r.to}`}
              onClick={() => go(r.to)}
              className="flex w-full items-center justify-between px-3 py-2.5 text-left text-sm text-navy/80 transition-colors hover:bg-mist hover:text-brand"
            >
              <span>{r.label}</span>
              <span className="mono-label text-[0.6rem] text-steel">{r.group}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
